// The structural sign-off's open feedback points behind its count, grouped by who must
// act on each as its point records (never assumed from the ask it sits on), most first as
// the count's own line names them
// (amazon_overview._signoff_step). The Step 2 hover card and the Step 3 card both open it.
import type { OpenPoint } from "../../api/hooks/useAmazonOverview";
import { Chevron } from "../../components/Chevron";
import { day, formatDate } from "./dates";
import styles from "./amazonOverview.module.css";

export const OpenPoints = ({ points }: { points: OpenPoint[] }) => {
  const byWho = new Map<string, OpenPoint[]>();
  for (const p of points) byWho.set(p.owed_by, [...(byWho.get(p.owed_by) ?? []), p]);
  const groups = [...byWho].sort((x, y) => y[1].length - x[1].length);
  return (
    <details className={styles.cardMore}>
      <summary>
        Which points <Chevron />
      </summary>
      {groups.map(([who, list]) => (
        <div key={who}>
          <p className={styles.cardListHead}>
            {who ? `On ${who}` : "No one on record"} ({list.length})
          </p>
          <ul>
            {[...list]
              .sort((x, y) => x.raised_on.localeCompare(y.raised_on))
              .map((p, i) => (
                <li key={i}>
                  {p.text}{" "}
                  <span className={styles.askFacts}>
                    Raised by {p.raised_by || "not on record"}
                    {p.raised_on && `, ${formatDate(day(p.raised_on))}`}
                    {p.source && ` · Email: “${p.source}”`}
                  </span>
                </li>
              ))}
          </ul>
        </div>
      ))}
    </details>
  );
};
